import React from 'react';
import Icon from './Icon';
import styles from './Badge.module.css';

export interface BadgeProps {
  label: string;
  icon?: string;
  type?: 'text' | 'number' | 'status';
  location?: 'inline' | 'top-right' | 'top-left';
  variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'danger'
    | 'info'
    | 'committee'
    | 'subprocess-status'
    | 'subprocess-substatus'
    | 'subprocess-substatus-success'
    | 'subprocess-substatus-danger'
    | 'subprocess-substatus-muted';
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  label,
  icon,
  type = 'text',
  location = 'inline',
  variant = 'primary',
  className = '',
}) => {
  const getBadgeClasses = () => {
    const classes = [
      'uc-status',
      styles.badge,
      styles[type],
      styles[location],
      styles[variant],
    ];

    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return (
    <span className={getBadgeClasses()}>
      {icon && <Icon name={icon} size="sm" />}
      {label}
    </span>
  );
};

export default Badge;
